import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import styles from '../styles/mobileNav1.module.css';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';

function MobileNav({ onCategoryChange }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNav = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={styles['nav-mob-container']}>

        <img className={styles['logo']} onClick={() => onCategoryChange('popular')} src="./logo.png" alt="Films 4 u logo" />

      <Container className={styles['nav-link-menu']}>
          {isOpen && (
            <div className={styles['mobile-links']}>
              <div onClick={() => { onCategoryChange('popular'); toggleNav(); }}>Popular</div>
              <div onClick={() => {onCategoryChange('top_rated'); toggleNav(); }}>Top Rated</div>
              <div onClick={() => {onCategoryChange('now_playing'); toggleNav(); }}>Now Playing</div>
              <div onClick={() => {onCategoryChange('trending'); toggleNav(); }}>Trending</div>
              <div onClick={() => {onCategoryChange('horror'); toggleNav(); }}>Horror</div>
            <div onClick={() => {onCategoryChange('action'); toggleNav(); }}>Action</div>
            <div onClick={() => {onCategoryChange('crime'); toggleNav(); }}>Crime</div>
            <div onClick={() => {onCategoryChange('comedy'); toggleNav(); }}>Comedy</div>
            <div onClick={() => {onCategoryChange('drama'); toggleNav(); }}>Drama</div>
            <div onClick={() => {onCategoryChange('adventure'); toggleNav(); }}>Adventure</div>
            </div>
          )}
        </Container> 
      <FontAwesomeIcon
        icon={isOpen ? faTimes : faBars}
        onClick={toggleNav}
        className={styles['hamburger']}
      />


      <Navbar
        expand="lg"
        className={`${styles['navbar']} ${isOpen ? styles['open'] : ''}`}
        style={{ justifyContent: isOpen ? 'center' : 'flex-end' }}
      >

      </Navbar>
    </div>
  );
}

export default MobileNav;
